import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientRequestsPage from "@/pages/client/ClientRequestsPage";

export const Route = createFileRoute("/client/requests")({
  head: () => pageHead("Client · Requests", "AKIVA client · requests portal.", "/client/requests", true),
  component: ClientRequestsPage,
});
